import React from 'react';

const PermissionDenied = () => (
  <div className="permission-denied-wrapper">
    <p>You don't have the permission to see this...</p>
  </div>
);

export default PermissionDenied;
